"use strict";

var _interopRequireDefault = require("/root/workspace/mall_vue_JOYE/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
require("core-js/modules/es7.object.get-own-property-descriptors");
require("core-js/modules/web.dom.iterable");
require("core-js/modules/es6.object.keys");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _defineProperty2 = _interopRequireDefault(require("/root/workspace/mall_vue_JOYE/node_modules/@babel/runtime-corejs2/helpers/defineProperty.js"));
require("core-js/modules/es6.string.ends-with");
require("core-js/modules/es6.string.starts-with");
require("core-js/modules/es6.regexp.split");
require("core-js/modules/es7.string.pad-start");
require("regenerator-runtime/runtime");
var _asyncToGenerator2 = _interopRequireDefault(require("/root/workspace/mall_vue_JOYE/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator.js"));
require("core-js/modules/es6.number.constructor");
var _qy_group_dinner = require("@/api/goods_activity/qy_group_dinner");
var _shareConfig = require("@/api/decorate/shareConfig");
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; } //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'QyGroupDinnerConfigPane',
  props: {
    activityId: {
      type: Number,
      default: null
    }
  },
  data: function data() {
    return {
      form: {
        activityName: '',
        scenes: [],
        activityTimeRange: [],
        imagePrefix: '',
        discountSubType: 1,
        pointsSwitch: true,
        balancePaySwitch: true,
        shareImageUrl: '',
        minAmount: null,
        minQuantity: null,
        ruleDescription: '',
        bookingDateRange: [],
        bookingStartTime: null,
        bookingEndTime: null,
        xyGroupDinnerConfigDetailEntities: [{
          minAmount: '',
          discountAmount: ''
        }]
      },
      loading: false,
      shareImageFile: null,
      shareImagePreviewUrl: ''
    };
  },
  computed: {
    getThresholdLabel: function getThresholdLabel() {
      var labels = {
        1: '满金额',
        2: '满金额',
        3: '满份数',
        4: '满份数'
      };
      return labels[this.form.discountSubType] || '门槛值';
    },
    getThresholdUnit: function getThresholdUnit() {
      return this.form.discountSubType === 1 || this.form.discountSubType === 2 ? '元' : '份';
    },
    getDiscountLabel: function getDiscountLabel() {
      var labels = {
        1: '减金额',
        2: '折扣',
        3: '减金额',
        4: '折扣'
      };
      return labels[this.form.discountSubType] || '优惠值';
    },
    getDiscountUnit: function getDiscountUnit() {
      return this.form.discountSubType === 1 || this.form.discountSubType === 3 ? '元' : '折';
    },
    isDiscountType: function isDiscountType() {
      return this.form.discountSubType === 2 || this.form.discountSubType === 4;
    }
  },
  mounted: function () {
    var _mounted = (0, _asyncToGenerator2.default)(/*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      return regeneratorRuntime.wrap(function (_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _context.next = 1;
            return this.getImagePrefix();
          case 1:
            if (this.activityId) {
              this.loadActivityData();
            }
          case 2:
          case "end":
            return _context.stop();
        }
      }, _callee, this);
    }));
    function mounted() {
      return _mounted.apply(this, arguments);
    }
    return mounted;
  }(),
  methods: {
    // 获取图片前缀
    getImagePrefix: function () {
      var _getImagePrefix2 = (0, _asyncToGenerator2.default)(/*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var response, _t;
        return regeneratorRuntime.wrap(function (_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _context2.prev = 0;
              _context2.next = 1;
              return (0, _shareConfig.getImagePrefix)();
            case 1:
              response = _context2.sent;
              if (response.code === 200 && response.data) {
                this.imagePrefix = response.data;
              }
              _context2.next = 3;
              break;
            case 2:
              _context2.prev = 2;
              _t = _context2["catch"](0);
              console.error('获取图片前缀失败:', _t);
            case 3:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this, [[0, 2]]);
      }));
      function getImagePrefix() {
        return _getImagePrefix2.apply(this, arguments);
      }
      return getImagePrefix;
    }(),
    // 将时间戳转换为yyyy-MM-dd格式
    formatTimestampToDate: function formatTimestampToDate(startTime, endTime) {
      var format = function format(timestamp) {
        var date = new Date(timestamp);
        var year = date.getFullYear();
        var month = String(date.getMonth() + 1).padStart(2, '0');
        var day = String(date.getDate()).padStart(2, '0');
        return "".concat(year, "-").concat(month, "-").concat(day);
      };
      return [format(startTime), format(endTime)];
    },
    loadActivityData: function loadActivityData() {
      var _this = this;
      this.loading = true;
      (0, _qy_group_dinner.getQyGroupDinnerDetail)(this.activityId).then(function (response) {
        var data = response.data;
        _this.form = {
          id: data.id,
          activityName: data.activityName || '',
          scenes: data.scenes ? data.scenes.split(',') : ['1', '2', '3'],
          activityTimeRange: [data.startTime ? new Date(data.startTime) : new Date(), data.endTime ? new Date(data.endTime) : new Date(new Date().getTime() + 30 * 24 * 60 * 60 * 1000)],
          discountSubType: data.discountSubType || 1,
          pointsSwitch: data.pointsSwitch !== undefined ? data.pointsSwitch : true,
          balancePaySwitch: data.balancePaySwitch !== undefined ? data.balancePaySwitch : true,
          shareImageUrl: data.shareImageUrl || '',
          minAmount: data.minAmount || null,
          minQuantity: data.minQuantity || null,
          ruleDescription: data.ruleDescription || '',
          bookingDateRange: data.bookingStartDate && data.bookingEndDate ? _this.formatTimestampToDate(data.bookingStartDate, data.bookingEndDate) : [],
          bookingStartTime: data.bookingStartTime || null,
          bookingEndTime: data.bookingEndTime || null,
          xyGroupDinnerConfigDetailEntities: data.xyGroupDinnerConfigDetailEntities || [{
            minAmount: 100,
            discountAmount: 10
          }, {
            minAmount: 200,
            discountAmount: 25
          }]
        };
      }).catch(function (error) {
        console.error('获取企业团餐详情失败:', error);
        _this.$message.error('获取数据失败');
      }).finally(function () {
        _this.loading = false;
      });
    },
    addDiscountRule: function addDiscountRule() {
      this.form.xyGroupDinnerConfigDetailEntities.push({
        minAmount: '',
        discountAmount: ''
      });
    },
    removeDiscountRule: function removeDiscountRule(index) {
      this.form.xyGroupDinnerConfigDetailEntities.splice(index, 1);
    },
    // 折扣值失焦验证和格式化
    handleDiscountBlur: function handleDiscountBlur(index) {
      if (this.isDiscountType) {
        var value = parseFloat(this.form.xyGroupDinnerConfigDetailEntities[index].discountAmount);
        if (isNaN(value)) {
          value = 1;
        }
        // 限制在 1-10 之间
        if (value < 1) value = 1;
        if (value > 10) value = 10;
        // 保留一位小数
        this.form.xyGroupDinnerConfigDetailEntities[index].discountAmount = parseFloat(value.toFixed(1));
      }
    },
    // 分享图片选择变化
    handleShareImageChange: function handleShareImageChange(file, fileList) {
      if (file.raw) {
        this.shareImageFile = file.raw;
        // 预览图片 - 使用临时变量，不修改 shareImageUrl
        this.shareImagePreviewUrl = URL.createObjectURL(file.raw);
      }
    },
    // 上传前验证
    beforeShareImageUpload: function beforeShareImageUpload(file) {
      var isImage = file.type.startsWith('image/');
      var isLt2M = file.size / 1024 / 1024 < 2;
      if (!isImage) {
        this.$message.error('分享图片只能是图片格式!');
        return false;
      }
      if (!isLt2M) {
        this.$message.error('分享图片大小不能超过 2MB!');
        return false;
      }
      return true;
    },
    // 删除分享图片
    handleRemoveShareImage: function handleRemoveShareImage() {
      this.form.shareImageUrl = '';
      this.shareImagePreviewUrl = '';
      this.shareImageFile = null;
      if (this.$refs.shareImageUpload) {
        this.$refs.shareImageUpload.clearFiles();
      }
    },
    // 获取图片URL
    getImageUrl: function getImageUrl(url) {
      // 如果没有url则返回空
      if (!url) return '';

      // 如果已经是完整URL则直接返回
      if (url.startsWith('http')) {
        return url;
      }

      // 如果有图片前缀，使用图片前缀
      if (this.imagePrefix) {
        // 确保前缀末尾没有斜杠，url开头有斜杠
        var prefix = this.imagePrefix.endsWith('/') ? this.imagePrefix.slice(0, -1) : this.imagePrefix;
        var path = url.startsWith('/') ? url : '/' + url;
        return prefix + path;
      }

      // 如果是相对路径，则加上基础URL
      return process.env.VUE_APP_BASE_API + url;
    },
    handleSave: function handleSave() {
      var _this2 = this;
      this.$refs.formRef.validate(function (valid) {
        if (!valid) {
          return false;
        }
        _this2.loading = true;

        // 构建 FormData
        var formData = new FormData();

        // 添加表单数据
        var formClone = _objectSpread({}, _this2.form);
        formClone.startTime = _this2.form.activityTimeRange[0];
        formClone.endTime = _this2.form.activityTimeRange[1];
        formClone.scenes = _this2.form.scenes.join(',');
        // 处理可预订日期区间
        if (_this2.form.bookingDateRange && _this2.form.bookingDateRange.length === 2) {
          formClone.bookingStartDate = _this2.form.bookingDateRange[0];
          formClone.bookingEndDate = _this2.form.bookingDateRange[1];
        }
        // 处理可预订时段
        if (_this2.form.bookingStartTime) {
          formClone.bookingStartTime = _this2.form.bookingStartTime;
        }
        if (_this2.form.bookingEndTime) {
          formClone.bookingEndTime = _this2.form.bookingEndTime;
        }
        delete formClone.activityTimeRange;
        delete formClone.bookingDateRange;
        // 分享图片URL保留在表单中，用于判断是否需要删除图片

        formData.append('formData', JSON.stringify(formClone));

        // 添加图片文件
        if (_this2.shareImageFile) {
          formData.append('shareImageFile', _this2.shareImageFile);
        }
        (0, _qy_group_dinner.saveQyGroupDinner)(formData).then(function () {
          _this2.$message.success('保存成功');
          // 保存成功后清空临时预览 URL 和文件
          _this2.shareImagePreviewUrl = '';
          _this2.shareImageFile = null;
          _this2.$emit('save');
        }).catch(function (error) {
          console.error('保存企业团餐失败:', error);
          _this2.$message.error(error.response && error.response.data && error.response.data.msg || '保存失败');
        }).finally(function () {
          _this2.loading = false;
        });
      });
    },
    handleCancel: function handleCancel() {
      this.$emit('cancel');
    }
  }
};